import type { AnchorHTMLAttributes, MouseEvent, ReactNode } from 'react';
import { isNative, openExternal } from '../lib/platform';

/*
 * O legatura care iese din aplicatie.
 *
 * Pe web e o ancora obisnuita, nimic schimbat: adresa reala in `href`, deci
 * merge click cu rotita, "copiaza adresa", si cititoarele de ecran o anunta ca
 * legatura. `target="_blank"` cu `rel="noopener noreferrer"`, ca pana acum.
 *
 * In carcasa nativa, `target="_blank"` nu duce nicaieri util: fie nu se intampla
 * nimic, fie pagina se incarca peste aplicatie si omul ramane fara drum inapoi -
 * nu exista bara de adrese, nici buton de browser. De aceea clicul e oprit si
 * adresa se deschide intr-un browser in-app, cu buton de inchidere, care lasa
 * aplicatia unde era.
 *
 * `href` ramane pus si pe nativ, chiar daca nu e urmat: fara el elementul nu mai
 * e o legatura pentru tehnologiile asistive si nu mai poate primi focus cu
 * tastatura.
 */
type Props = AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string;
  children: ReactNode;
};

export function ExternalLink({ href, children, onClick, ...rest }: Props) {
  function handleClick(event: MouseEvent<HTMLAnchorElement>): void {
    onClick?.(event);

    if (!isNative || event.defaultPrevented) return;

    event.preventDefault();
    void openExternal(href);
  }

  return (
    <a {...rest} href={href} target="_blank" rel="noopener noreferrer" onClick={handleClick}>
      {children}
    </a>
  );
}
